"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CameraReadiness = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _ReadinessCheck = _interopRequireDefault(require("../ReadinessCheck"));
var _constants = require("../../../constants");
var CameraReadiness = exports.CameraReadiness = function CameraReadiness(_ref) {
  var status = _ref.status,
    onRetry = _ref.onRetry,
    hideBottomBorder = _ref.hideBottomBorder,
    statusText = _ref.statusText,
    messageBody = _ref.messageBody,
    presenterId = _ref.presenterId,
    camera = _ref.camera;
  return /*#__PURE__*/_react["default"].createElement(_ReadinessCheck["default"], {
    title: "Camera",
    status: status,
    statusText: statusText,
    onRetry: onRetry,
    hideBottomBorder: hideBottomBorder,
    failedText: camera === _constants.NO_DEVICE_FOUND ? 'No camera device detected' : 'Browser permission not granted',
    presenterId: presenterId
  }, messageBody ? /*#__PURE__*/_react["default"].createElement("p", null, messageBody) : /*#__PURE__*/_react["default"].createElement("p", null, "\n        Check your browser privacy settings\n        allow ".concat(window.location.hostname, " access to\n        your camera.\n      ")));
};
CameraReadiness.defaultProps = {
  status: _constants.CHECKING
};
CameraReadiness.propTypes = {
  status: _propTypes.string.isRequired,
  messageBody: _propTypes.string,
  statusText: _propTypes.string,
  onRetry: _propTypes.func,
  presenterId: _propTypes.string,
  hideBottomBorder: _propTypes.bool,
  camera: _propTypes.string
};